var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.1 272.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "218.32 272.4 262.98 272.4 314.1 128.2 314.1 0 218.32 272.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.83,132.5a20.06,20.06,0,0,0-6.68-9.9c-3-2.31-7.05-3.48-12-3.48q-14.45,0-20.33,13.38L65.69,272.4h39.66L138,183.08l35.73,89.32h42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.18,213.33q-2.13-7.49-7.48-10.7a22.46,22.46,0,0,0-11.77-3.21q-10.17,0-16,6.42A22.1,22.1,0,0,0,0,221.35a24.18,24.18,0,0,0,1.6,8.56L17.11,272.4H61.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.8,91.49a29.07,29.07,0,1,0-29.07-29.07A29.07,29.07,0,0,0,140.8,91.49Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo_4.1b9b99d5c463d93f2e9492c8e050a7de.svg";
export { ForwardRef as ReactComponent };